<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="section-header">
          <h3>Forfaits</h3>
          <p class="text-muted font-weight-light">
            Sélectionner le forfait que tu souhaites activer
          </p>
        </div>
      </div>
    </div>
    <div v-if="$store.state.core.bundles==null" class="row">
      <div class="col-md-3">
         <b-skeleton height="120px"></b-skeleton>
      </div>
      <div class="col-md-3">
         <b-skeleton height="120px"></b-skeleton>
      </div>
      <div class="col-md-3">
         <b-skeleton height="120px"></b-skeleton>
      </div>
      <div class="col-md-3">
         <b-skeleton height="120px"></b-skeleton>
      </div>
    </div>

      <div v-if="$store.state.core.bundles!=null" class="row">
        <ServiceCard
          :key="index"
          v-for="(item, index) in $store.state.core.bundles.labels"
          :title="item.title"
          :link_type="'btn'"
          :modal_id="'bundle_sidebar_'+item.id"
        />
      </div>
 
  </div>
</template>

<script>
import ServiceCard from "@/components/utils/ServiceCard";
import {subscriber} from "@/services/"
export default {
  components: { ServiceCard },
  name: "BundleList",
  data: function () {
    return {};
  },
  mounted: async function () {
    await subscriber.get_bundle_list();
  },
  methods: {},
};
</script>
<style scoped lang="css">
</style>
